import { EntityType } from './common'

export type CounterRequestType = {
  entity_id: number
  entity_type: EntityType
}

export type CounterCommentsResponseType = CounterRequestType & {
  comments_count: number
}

export enum ReactionType {
  Fire = 'fire',
  WantToGo = 'want_to_go',
}

export type CounterReactionsResponseType = CounterRequestType & {
  count: number
  is_set_by_user?: boolean
  reaction: ReactionType
}

export type ReactionsCounters = Partial<
  Record<ReactionType, CounterReactionsResponseType>
>
